export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1200px] flex-col gap-xl px-xl py-lg',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	moduleMark:
		'inline-flex h-[44px] w-[44px] items-center justify-center rounded-lg border border-purple-100 bg-purple-50 text-purple-700 shrink-0',
	statsCard: 'flex items-end gap-lg rounded-lg border border-subtle bg-white px-md py-sm',
	statValue: 'text-[20px] font-semibold leading-none tabular-nums text-default',
	statValueBrand: 'text-[20px] font-semibold leading-none tabular-nums text-purple-700',
	statLabel: 'text-[10px] uppercase tracking-wider text-subtle',
	statLabelBrand: 'text-[10px] uppercase tracking-wider text-purple-700',
	sectionH: 'text-[15px] font-semibold leading-tight tracking-tight text-default',
	sectionSub: 'mt-3xs text-[12px] text-subtle',
	flowNode:
		'inline-flex flex-col items-center gap-3xs rounded-md border border-subtle bg-white px-sm py-2xs min-w-[100px]',
	flowNodeActive:
		'inline-flex flex-col items-center gap-3xs rounded-md border border-purple-200 bg-purple-25 px-sm py-2xs min-w-[100px]',
	flowNodeEnd:
		'inline-flex flex-col items-center gap-3xs rounded-md border border-subtle border-dashed bg-white px-sm py-2xs min-w-[100px] text-subtle',
	flowArrow: 'h-sm w-sm text-subtle',
	agentAvatar:
		'inline-flex h-[36px] w-[36px] items-center justify-center rounded-full border border-purple-100 bg-purple-50 text-[13px] font-semibold leading-none text-purple-700 shrink-0',
	badgeBrand:
		'inline-flex items-center gap-3xs rounded-md bg-purple-50 px-2xs py-3xs text-[11px] font-medium leading-none text-purple-700',
	badgeNeutral:
		'inline-flex items-center gap-3xs rounded-md bg-grey-25 px-2xs py-3xs text-[11px] font-medium leading-none text-subtle',
};
